import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import { IDealDocument } from '../types';

interface IGetDocumentQueryParams {
    documentId: number;
    options?: { enabled?: boolean };
}

const getDocument = async ({ documentId }: IGetDocumentQueryParams): Promise<IDealDocument> => {
    const response = await axiosInstance.get(`${API_ENDPOINTS.DEAL_DOCUMENTS.DOCUMENT_BY_ID(documentId)}`);
    return response.data;
};

export const useGetDocument = ({ documentId, options = {} }: IGetDocumentQueryParams) => useQuery({
    queryKey: [QUERY_KEYS.DOCUMENT_DETAIL, documentId],
    queryFn: () => getDocument({ documentId, options }),
    refetchOnMount: true,
    ...options,
});

export default useGetDocument;
